import clsx from 'clsx';
import { LinkWithMasking } from '../link';
import type { LabelLinkProps, LabelProps } from './types';
import styles from './Label.module.css';
import { TEXT_VARIANT } from '@pixum/text';

export function LabelWithLinkMasking(props: LabelLinkProps) {
  const { className, text, icon, showIcon = true, variant, masked, ...rest } = props;

  const mergedClassName = clsx(
    className,
    styles.wrapper,
    `text--${variant || TEXT_VARIANT.CAPTION}`,
    masked && styles['wrapper--masked'],
  );

  return (
    <>
      {(text || icon) && (
        <LinkWithMasking className={mergedClassName} masked={masked} {...rest}>
          {showIcon && icon ? <div className={styles.icon}>{icon}</div> : <></>}
          <>{text}</>
        </LinkWithMasking>
      )}
    </>
  );
}

export function Label(props: LabelProps) {
  const { className, text, icon, showIcon = true } = props;

  return (
    <>
      {(text || icon) && (
        <div className={clsx(className, styles.wrapper, `text--${props.variant || 'caption'}`)}>
          {showIcon && icon ? <div className={styles.icon}>{icon}</div> : <></>}
          <>{text}</>
        </div>
      )}
    </>
  );
}
